module.exports = {
      id: "sun-usage",
      viewBox: "0 0 512 512",
      url: "/" + "svg-sprite-21c17c4d458cf2e2be6dd4c01f9ab03b.svg#sun",
      toString: function () {
        return this.url;
      }
    }